import { type ReactNode } from 'react';

export function Kicker({ children }: { children: ReactNode }) {
  return (
    <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-500">
      <span className="hairline inline-block w-6" />
      {children}
    </p>
  );
}

export function SectionHead({
  kicker,
  title,
  desc,
  action,
}: {
  kicker: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        <Kicker>{kicker}</Kicker>
        <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-3 text-sm leading-6 text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {action}
    </div>
  );
}

export function ProgressBadge({ label }: { label: string }) {
  const map: Record<string, string> = {
    已复盘: 'bg-primary-100 text-primary-800',
    反转中: 'bg-accent-100 text-accent-800',
    跟进中: 'bg-secondary-100 text-secondary-800',
    已澄清: 'bg-foreground-100 text-foreground-700',
  };
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ${map[label] ?? map.已复盘}`}>
      <span className="mr-1 inline-block h-1.5 w-1.5 rounded-full bg-current" aria-hidden="true" />
      {label}
    </span>
  );
}